// @flow

import * as React from 'react'
import { Container, Segment, Button } from 'semantic-ui-react'
import { Form, Fields, Validators } from 'react-redux-components'

import { type Visit } from '../store/manage-visits'

type Props = {|
  loadedRecord: Array<string>,
  pristine: boolean,
  onSubmit: (visit: Visit) => void,
  onCancel: () => void,
|}

class VisitsForm extends React.Component<Props> {
  validators = {
    id_medico: { required: Validators.required },
    data_visita: { required: Validators.required },
    prodotto: { required: Validators.required },
    canale: { required: Validators.required },
  }

  render() {
    let TextInput = Fields.TextInput
    let stdErrMsg = { required: 'Campo obbligatorio' }
    return (
      <Container>
        <Form onSubmit={this.props.onSubmit} model="visits.form" dimmable={true} validators={this.validators}>
          <Segment color="orange" secondary>
            <div className="ui grid" style={{ margin: '0 2ex' }}>
              <div className="four wide column">
                <TextInput label="ID Medico" model=".id_medico" disabled={true} />
              </div>
              <div className="six wide column">
                <TextInput label="Nome medico" model=".nome" disabled={true} />
              </div>
              <div className="six wide column">
                <TextInput label="Cognome medico" model=".cognome" disabled={true} />
              </div>

              <div className="sixteen wide column" style={{ paddingTop: 0, paddingBottom: '1rem' }} />

              <div className="four wide column">
                <TextInput label="Data visita" model=".data_visita" disabled={true} errorMessages={stdErrMsg} />
              </div>
              <div className="six wide column">
                <TextInput label="Caricato da" model=".uploaded_by" disabled={true} />
              </div>
              <div className="six wide column">
                <TextInput label="Prodotto" model=".prodotto" errorMessages={stdErrMsg} />
              </div>

              <div className="sixteen wide column" style={{ paddingTop: 0, paddingBottom: '1rem' }} />

              <div className="seven wide column">
                <TextInput label="ISF" model=".isf" />
              </div>
              <div className="four wide column">
                <Fields.ComboBox
                  label="Canale"
                  model=".canale"
                  options={[
                    { value: 'PHONE', text: 'PHONE' },
                    { value: 'WEB', text: 'WEB' },
                    { value: 'F2F', text: 'F2F' },
                  ]}
                />
              </div>

              <div className="sixteen wide column" style={{ paddingTop: 0, paddingBottom: '1rem' }} />

              <div className="six wide column">
                <TextInput label="Wave" model=".wave" />
              </div>
              <div className="five wide column">
                <Fields.Rating label="Call experience" model=".call_experience" max={3} icon="star" />
              </div>

              <div className="sixteen wide column" style={{ paddingTop: 0, paddingBottom: '1rem' }} />
            </div>

            <div className="ui  grid" style={{ marginTop: '7ex' }}>
              <div className="two column row">
                <div className="right floated column">
                  <Button
                    icon="save"
                    content="Salva"
                    labelPosition="left"
                    primary
                    disabled={this.props.pristine}
                    className="right floated"
                    type="submit"
                    style={{ width: '18ex' }}
                  />
                  <Button
                    type="button"
                    icon="cancel"
                    content="Annulla"
                    labelPosition="left"
                    className="right floated"
                    onClick={this.props.onCancel}
                    style={{ width: '18ex' }}
                  />
                </div>
              </div>
            </div>
          </Segment>
        </Form>
      </Container>
    )
  }
}

export default VisitsForm



// WEBPACK FOOTER //
// ./src/visits/visits-form.js